import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { typeof: "primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_TimeoutErrorComponent = _resolveComponent("TimeoutErrorComponent")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_affix, {
          offset: 0,
          position: "top",
          style: {"width":"100% !important"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                (_ctx.userAuthenticated)
                  ? (_openBlock(), _createBlock(_component_HeaderComponent, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.envName !== '')
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              class: "envClass"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Environment : " + _toDisplayString(_ctx.envName), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            (_ctx.userError)
              ? (_openBlock(), _createBlock(_component_ErrorMessage, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.requestErrors)
              ? (_openBlock(), _createBlock(_component_TimeoutErrorComponent, { key: 1 }))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
              [
                _directive_loading,
                _ctx.fetchingUserInfo,
                void 0,
                {
                  fullscreen: true,
                  lock: true
                }
              ]
            ]),
            (
            _ctx.userAuthenticated &&
            !_ctx.userError &&
            !_ctx.requestErrors &&
            !_ctx.fetchingUserInfo
          )
              ? (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}